<template>
  <div>
    <Modal v-model="visible" title="请选择需要结算的数据" width="1400" :mask-closable="false" :footer-hide="true" :fullscreen="true">
      <div class="search-container">
        <div class="search-box" :class="{ close: !searchMore }">
          <div class="input-item" v-if="$units.superviseShowVal()">
            <span class="label">供应商类型</span>
            <RadioGroup v-model="formData.supplierType" @on-change="changeSupplierType">
              <Radio label="">全部</Radio>
              <Radio label="1">保司</Radio>
              <Radio label="2">通道</Radio>
            </RadioGroup>
          </div>

          <div class="input-item" v-if="formData.supplierType">
            <span class="label">供应商</span>
            <Select v-model="formData.supplierId" placeholder="请选择" filterable clearable transfer>
              <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">保险公司</span>
            <Select v-model="formData.companyCode" placeholder="请选择" filterable clearable transfer>
              <Option v-for="(bean, i) in companyList" :key="i" :value="bean.code">{{ bean.name }}</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">保单号</span>
            <Input type="text" v-model="formData.policyNo" clearable placeholder="请输入" />
          </div>

          <div class="input-item">
            <span class="label">产品名称</span>
            <Select v-model="formData.productCode" clearable transfer filterable>
              <Option :value="item.productCode" v-for="(item, index) in productList" :key="index">{{ item.productCode }}/{{ item.productName }}</Option>
            </Select>
          </div>

          <div class="input-item select-two">
            <Select v-model="dateType" :transfer="true">
              <Option value="3">承保日期</Option>
              <Option value="1">投保日期</Option>
              <Option value="2">支付日期</Option>
              <Option value="7">生效日期</Option>
            </Select>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="date"
              @on-change="date = $event"
            ></DatePicker>
          </div>

          <div class="input-item select-two">
            <Select v-model="dateType3" :transfer="true">
              <Option value="1">应收日期</Option>
              <Option value="2">宽限期满日</Option>
            </Select>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="formData.date3"
              @on-change="formData.date3 = $event"
            ></DatePicker>
          </div>

          <div class="input-item">
            <span class="label">保单年度</span>
            <Input type="number" v-model="formData.commissionIndex" placeholder="请输入" />
          </div>

          <div class="input-item">
            <span class="label">交费期次</span>
            <Input type="number" v-model="formData.commissionPeriods" placeholder="请输入" />
          </div>

          <div class="input-item">
            <span class="label">保单状态</span>
            <Select v-model="formData.policyStatusList" clearable transfer multiple>
              <Option value="1">已承保</Option>
              <Option value="-1">已退保</Option>
              <Option value="0">已终止</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">回执状态</span>
            <Select
              v-model="formData.receiptStatusList"
              clearable
              transfer
              multiple
              :disabled="formData.receiptStatusNull && formData.receiptStatusNull.length ? true : false"
            >
              <Option value="-1">无需回执</Option>
              <Option value="0">待回执</Option>
              <Option value="1">回执成功</Option>
              <Option value="2">回执失败</Option>
            </Select>
            <CheckboxGroup
              v-model="formData.receiptStatusNull"
              style="margin-left: 10px; width: 100px"
              @on-change="changeTimeNull($event, 'receiptStatusList')"
            >
              <Checkbox label="1">为空</Checkbox>
            </CheckboxGroup>
          </div>

          <div class="input-item select-two">
            <Select v-model="dateType2" :transfer="true" style="width: 115px; min-width: 115px;">
              <Option value="1">回执签收日期</Option>
              <Option value="2">回执回销日期</Option>
            </Select>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="formData.date2"
              @on-change="formData.date2 = $event"
              :disabled="formData.dateTimeNull && formData.dateTimeNull.length ? true : false"
              class="date-picker"
            ></DatePicker>
            <CheckboxGroup v-model="formData.dateTimeNull" style="margin-left: 10px; width: 70px; min-width: 70px" @on-change="changeTimeNull($event, 'date2')">
              <Checkbox label="1">为空</Checkbox>
            </CheckboxGroup>
          </div>

          <div class="input-item">
            <span class="label">回访状态</span>
            <Select
              v-model="formData.verifyStatusList"
              clearable
              transfer
              multiple
              :disabled="formData.verifyStatusNull && formData.verifyStatusNull.length ? true : false"
            >
              <Option value="0">等待回访</Option>
              <Option value="1">回访成功</Option>
              <Option value="2">回访失败</Option>
              <Option value="3">无需回访</Option>
            </Select>
            <CheckboxGroup v-model="formData.verifyStatusNull" style="margin-left: 10px; width: 100px" @on-change="changeTimeNull($event, 'verifyStatusList')">
              <Checkbox label="1">为空</Checkbox>
            </CheckboxGroup>
          </div>

          <div class="input-item">
            <span class="label">回访日期</span>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="formData.verifyDate"
              @on-change="formData.verifyDate = $event"
              :disabled="formData.revisitTimeNull && formData.revisitTimeNull.length ? true : false"
            ></DatePicker>
            <CheckboxGroup v-model="formData.revisitTimeNull" style="margin-left: 10px; width: 100px" @on-change="changeTimeNull($event, 'verifyDate')">
              <Checkbox label="1">为空</Checkbox>
            </CheckboxGroup>
          </div>

          <div class="input-item">
            <span class="label">犹豫止期</span>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="formData.hesitateDate"
              @on-change="formData.hesitateDate = $event"
              :disabled="formData.hesitateTimeNull && formData.hesitateTimeNull.length ? true : false"
            ></DatePicker>
            <CheckboxGroup v-model="formData.hesitateTimeNull" style="margin-left: 10px; width: 100px" @on-change="changeTimeNull($event, 'hesitateDate')">
              <Checkbox label="1">为空</Checkbox>
            </CheckboxGroup>
          </div>

          <div class="input-item">
            <span class="label">退保日期</span>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="formData.refundDate"
              @on-change="formData.refundDate = $event"
              :disabled="formData.refundTimeNull && formData.refundTimeNull.length ? true : false"
            ></DatePicker>
            <CheckboxGroup v-model="formData.refundTimeNull" style="margin-left: 10px; width: 100px" @on-change="changeTimeNull($event, 'refundDate')">
              <Checkbox label="1">为空</Checkbox>
            </CheckboxGroup>
          </div>

          <div class="input-item">
            <span class="label">险种分类</span>
            <Select v-model="formData.themeIds" placeholder="请选择" clearable multiple filterable>
              <Option v-for="item in productThemeList" :key="item.id" :value="item.id" :label="item.name"> </Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">业务类别</span>
            <Select
              v-model="formData.sellType"
              placeholder="请选择"
              multiple
              :disabled="formData.sellTypeStatusNull && formData.sellTypeStatusNull.length ? true : false"
            >
              <Option value="1">网销产品</Option>
              <Option value="3">经代产品</Option>
            </Select>
            <CheckboxGroup v-model="formData.sellTypeStatusNull" style="margin-left: 10px; width: 100px" @on-change="changeTimeNull($event, 'sellType')">
              <Checkbox label="1">为空</Checkbox>
            </CheckboxGroup>
          </div>

          <div class="input-item">
            <span class="label">机构</span>
            <Select v-model="formData.orgIds" multiple clearable filterable :max-tag-count="1">
              <Option v-for="item in orgList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">出单业务员</span>
            <lzSelect v-model="formData.salesmanId" placeholder="请输入姓名或工号搜索" ref="salesmanSelect" :remote-method="getUserList">
              <template slot-scope="{ list }">
                <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name">
                  <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
                  {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
                </Option>
              </template>
            </lzSelect>
          </div>

          <div class="input-item">
            <span class="label">费用归属</span>
            <lzSelect v-model="formData.owerId" placeholder="请输入姓名或工号搜索" ref="owerSelect" :remote-method="getUserList">
              <template slot-scope="{ list }">
                <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name">
                  <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
                  {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
                </Option>
              </template>
            </lzSelect>
          </div>

          <div class="input-item">
            <span slot="label" class="label">
              是否扣款记录<span class="tip-icon">?</span>
              <div class="pop-tip">
                <span>因退保等原因已扣除费用的记录</span>
                <div class="arrow"></div>
              </div>
            </span>

            <RadioGroup v-model="formData.isDeduct" @on-change="searchAjax">
              <Radio label="">全部</Radio>
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </div>
          <div class="input-item">
            <span class="label">是否自互保件</span>
            <RadioGroup v-model="formData.isSelfInsurance" @on-change="searchAjax">
              <Radio label="">全部</Radio>
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </div>

          <div class="input-item">
            <span class="label">费用类型</span>
            <Select v-model="formData.commissionStyles" clearable transfer multiple>
              <Option value="1">基础费用</Option>
              <Option value="2">团队长基础管理费</Option>
              <Option value="3">限时加费</Option>
              <Option value="4">后置费用</Option>
              <Option value="5">团队长后置管理费</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">长短险标志</span>
            <Select v-model="formData.productType" clearable transfer>
              <Option value="1">长险</Option>
              <Option value="2">短险</Option>
            </Select>
          </div>

        </div>
        <div class="btn-item btn-box">
          <Button type="primary" @click="searchAjax">查询</Button>
          <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
            >收起
            <Icon type="ios-arrow-up" />
          </Button>
          <Button type="primary" ghost v-else @click="searchMore = true"
            >展开
            <Icon type="ios-arrow-down" />
          </Button>
        </div>
      </div>

      <!-- 工具栏 -->
      <div class="tools-box">
        <div class="left-box">
          <Checkbox v-model="isAll" @on-change="selectAll">全部</Checkbox>
        </div>
        <div class="right-box">
          <span class="text"
            >已选择<span>{{ isAll ? total : selectArr.length }}</span
            >条，共<span>{{ total }}</span
            >条数据</span
          >
        </div>
      </div>

      <div class="tableBox">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange"> </Table>
      </div>
      <Page
        :total="total"
        :current.sync="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        style="text-align: center; margin-top: 20px; margin-bottom: 50px"
      />
      <div class="footer-btn">
        <Button type="primary" @click="ok" :loading="loading" size="default">加入结算</Button>
        
        <Button @click="visible = false" size="default">取消</Button>   
        <Button type="warning" @click="exportTable">导出</Button>     
      </div>
    </Modal>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';
import lzSelect from '@/components/commons/lzSelect';
export default {
  mixins: [pageTool, common],
  components: {
    lzSelect
  },
  props: ['reportId'],
  data() {
    return {
      visible: false,
      loading: false,
      dateType: '3',
      dateType2: '1',
      dateType3: '1',
      date: [],
      formData: {
        isDeduct: '',
        supplierType: '',
        orgIds: [],
        sellType: []
      },
      productList: [],
      companyList: [],
      supplierList: [],
      productThemeList: [],
      total: null,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 160,
          fixed: 'left'
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '业务类别',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let sellType = params.row.sellType&&JSON.parse(params.row.sellType);
            if (sellType.includes('1')) {
              return <span>网销产品</span>;
            } else if (sellType.includes('3')) {
              return <span>经代产品</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '险种分类',
          align: 'center',
          key: 'themeName',
          minWidth: 120
        },
        {
          title: '长短险标志',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            if (params.row.productType == '1') {
              return <span>长险</span>;
            } else if (params.row.productType == '2') {
              return <span>短险</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '保单状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            if (params.row.policyStatus == 1) {
              return <span>已承保</span>;
            } else if (params.row.policyStatus == '0') {
              return <span>已终止</span>;
            } else if (params.row.policyStatus == 2) {
              return <span>续保</span>;
            } else if (params.row.policyStatus == -1) {
              return <span>已退保</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filter.filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回执状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            if (params.row.receiptStatus == '-1') {
              return <span>无需回执</span>;
            } else if (params.row.receiptStatus == '0') {
              return <span>待回执</span>;
            } else if (params.row.receiptStatus == '1') {
              return <span>回执成功</span>;
            } else if (params.row.receiptStatus == '2') {
              return <span>回执失败</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '回执回销日期',
          align: 'center',
          key: 'receiptDate',
          minWidth: 130,
          render(h, params) {
            let receiptDate = params.row.receiptDate;
            return <span>{filter.filterTime(receiptDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回访状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            if (params.row.verifyStatus == '0') {
              return <span>等待回访</span>;
            } else if (params.row.verifyStatus == '1') {
              return <span>回访成功</span>;
            } else if (params.row.verifyStatus == '2') {
              return <span>回访失败</span>;
            } else if (params.row.verifyStatus == '3') {
              return <span>无需回访</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '回访日期',
          align: 'center',
          key: 'revisitDate',
          minWidth: 130,
          render(h, params) {
            let revisitDate = params.row.revisitDate;
            return <span>{filter.filterTime(revisitDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '犹豫止期',
          align: 'center',
          key: 'hesitateDate',
          minWidth: 130,
          render(h, params) {
            let hesitateDate = params.row.hesitateDate;
            return <span>{filter.filterTime(hesitateDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保障期',
          align: 'center',
          key: 'guaranteeDesc',
          minWidth: 120
        },
        {
          title: '交费期',
          align: 'center',
          key: 'payDesc',
          minWidth: 120
        },
        {
          title: '保单年度',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 100,
          render(h, params) {
            let commissionIndex = params.row.commissionIndex;
            return <span>{commissionIndex ? commissionIndex : '-'}</span>;
          }
        },
        {
          title: '交费期次',
          align: 'center',
          key: 'commissionPeriods',
          minWidth: 100
        },
        {
          title: '应收日期',
          align: 'center',
          key: 'needPayDate',
          minWidth: 120,
          render(h, params) {
            let time = params.row.needPayDate;
            return <span>{filter.filterTime(time, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '实收/支付日期',
          align: 'center',
          key: 'payTime',
          minWidth: 130,
          render(h, params) {
            let payTime = params.row.payTime;
            return <span>{filter.filterTime(payTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '费用归属/出单业务员',
          align: 'center',
          key: 'owerName',
          minWidth: 170,
          render(h, params) {
            let owerName = params.row.owerName;
            let salesmanName = params.row.salesmanName;
            return (
              <span>
                {owerName}/{salesmanName}
              </span>
            );
          }
        },
        {
          title: '费用类型',
          align: 'center',
          key: 'owerType ',
          minWidth: 160,
          render(h, params) {
            const owerType = params.row.owerType;
            const commissionType = params.row.commissionType;
            if (owerType == 2 && (commissionType == 1 || commissionType == 3 || commissionType == 7 || commissionType == 9)) {
              return <span>团队长基础管理费</span>;
            } else if (owerType == 3 && (commissionType == 1 || commissionType == 3 || commissionType == 7 || commissionType == 9)) {
              return <span>基础费用</span>;
            } else if (commissionType == 2 || commissionType == 4 || commissionType == 20 || commissionType == 8 || commissionType == 10) {
              return <span>限时加费</span>;
            } else if ((commissionType == 5 || commissionType == 21) && owerType == 3) {
              return <span>后置费用</span>;
            } else if ((commissionType == 5 || commissionType == 21) && owerType == 2) {
              return <span>团队长后置管理费</span>;
            }
          }
        },
        {
          title: '继承比',
          align: 'center',
          key: 'extendRate',
          minWidth: 100,
          render(h, params) {
            const extendRate = params.row.extendRate;
            return <span>{extendRate ? extendRate*100 + '%' : '-'}</span>;
          }
        },
        {
          align: 'center',
          key: 'commission',
          renderHeader: (h, params) => {
            return (
              <Tooltip
                trigger="hover"
                content="content"
                transfer={true}
              >
                <span>费率</span>
                <span class="tip-icon">?</span>
                <div slot="content">
                  <span>继承单的费率=出单时的费率*续期继承比例</span>
                </div>
              </Tooltip>
            );
          },
          minWidth: 120,
          render(h, params) {
            const commission = params.row.finalCommission;
            return <span>{commission ? commission + '%' : '-'}</span>;
          }
        },
        {
          title: '费用',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 135,
          render(h, params) {
            const commissionPrice = params.row.commissionPrice;
            const deductType = params.row.deductType;
            let msg = '';
            if (deductType == 1) {
              msg = '退保';
            } else if (deductType == 2) {
              msg = '部分退保';
            } else if (deductType == 3) {
              msg = '退现价';
            } else if (deductType == 4) {
              msg = params.row.deductMsg;
            }
            let isDeduct = params.row.isDeduct;
            if (isDeduct == '1') {
              return (
                <div style="display:flex; align-items: center; justify-content: center;">
                  <span>{commissionPrice ? commissionPrice : '-'}</span>
                  <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip min-width" transfer={true}>
                    <span style="height:20px; width:34px; font-size: 12px; border: 1px solid #ffcf8e; background: #fff3e3; color: #ff7f00; margin-left: 5px; padding: 2px 2px; cursor: pointer;">
                      扣款
                    </span>
                    <div slot="content">
                      <p>{msg}</p>
                    </div>
                  </Poptip>
                </div>
              );
            } else {
              return <span>{commissionPrice ? commissionPrice : '-'}</span>;
            }
          }
        },
        {
          title: '投保人',
          align: 'center',
          key: 'holderName',
          minWidth: 100
        },
        {
          title: '被保人',
          align: 'center',
          key: 'insuredName',
          minWidth: 100
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 150
        },
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 150
        },
        {
          title: '是否自保件',
          align: 'center',
          key: 'isSelfHold',
          minWidth: 120,
          render(h, params) {
            const value = params.row.isSelfHold;
            return <span>{value == 1 ? '是' : '否'}</span>;
          }
        },
        {
          title: '是否互保件',
          align: 'center',
          key: 'isMutualHold',
          minWidth: 120,
          render(h, params) {
            const value = params.row.isMutualHold;
            return <span>{value == 1 ? '是' : '否'}</span>;
          }
        },
      ],
      tableData: [],
      isAll: false, //全部产品
      selectArr: [], //表格选择的数据
      loading: false,
      selectOrgIds: [],
      orgList: [],
      reportName: '',
      settlementDate: ''
    };
  },
  methods: {
    async open(orgIds, reportName, settlementDate) {
      this.visible = true;
      this.isAll = false;
      this.selectArr = [];
      this.formData.orgIds = [];
      this.formData.sellType = [];
      this.date = [];
      this.dateType = '3';
      this.reportName = reportName;
      this.settlementDate = settlementDate;
      this.$set(this, 'selectOrgIds', orgIds);
      await this.getOrgList(orgIds);
      this.getSupplier();
      this.queryProduct();
      this.getBaosi();
      this.getProductTheme();
      this.searchAjax();
    },
    // 查询
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 重置
    resetSearch() {
      this.formData = {};
      this.date = [];
      this.dateType = '3';
      this.dateType2 = '1';
      this.dateType3 = '1';
      this.formData.isDeduct = '';
      this.formData.supplierType = '';
      this.formData.orgIds = [];
      this.formData.sellType = [];
      this.formData.orgIds = this.selectOrgIds;
      this.searchAjax();
    },
    changeTimeNull(value, key) {
      this.formData[key] = '';
    },
    parameter() {
      let data = JSON.parse(JSON.stringify(this.formData));
      if (!data.orgIds.length) {
        data.orgIds = this.selectOrgIds;
      }
      if (this.date && this.date[0]) {
        if (this.dateType == 1) {
          //投保日期
          data.holdTimeStart = this.date[0];
          data.holdTimeEnd = this.date[1];
        } else if (this.dateType == 2) {
          //支付日期
          data.payTimeStart = this.date[0];
          data.payTimeEnd = this.date[1];
        } else if (this.dateType == 3) {
          //承保日期
          data.insureTimeStart = this.date[0];
          data.insureTimeEnd = this.date[1];
        } else if (this.dateType == 7) {
          //生效日期
          data.effectTimeStart = this.date[0];
          data.effectTimeEnd = this.date[1];
        }
      }

      if (data.date3 && data.date3[0]) {
        //应收日期
        if (this.dateType3 == 1) {
          data.needPayDateStart = data.date3[0];
          data.needPayDateEnd = data.date3[1];
        } else if (this.dateType3 == 2) {
          //宽限期满日
          data.lastPayDateStart = data.date3[0];
          data.lastPayDateEnd = data.date3[1];
        }
      }
      delete data.date3;

      // 退保日期
      if (data.refundDate && data.refundDate[0]) {
        data.refundTimeStart = data.refundDate[0];
        data.refundTimeEnd = data.refundDate[1];
      }
      delete data.refundDate;
      if (data.refundTimeNull && data.refundTimeNull.length) {
        data.refundTimeIsNull = '1';
        delete data.refundTimeStart;
        delete data.refundTimeEnd;
        delete data.refundTimeNull;
      } else {
        delete data.refundTimeNull;
      }

      if (data.date2 && data.date2[0]) {
        //回执签收日期
        if (this.dateType2 == 1) {
          data.receiptDate2Start = data.date2[0];
          data.receiptDate2End = data.date2[1];
        } else if (this.dateType2 == 2) {
          //回执回销日期
          data.receiptDateStart = data.date2[0];
          data.receiptDateEnd = data.date2[1];
        }
      }
      delete data.date2;
      if (data.dateTimeNull && data.dateTimeNull.length && this.dateType2 == 1) {
        data.receiptDate2IsNull = '1';
        delete data.receiptDate2Start;
        delete data.receiptDate2End;
        delete data.dateTimeNull;
      } else if (data.dateTimeNull && data.dateTimeNull.length && this.dateType2 == 2) {
        data.receiptDateIsNull = '1';
        delete data.receiptDateStart;
        delete data.receiptDateEnd;
        delete data.dateTimeNull;
      } else {
        delete data.dateTimeNull;
      }

      // 回访日期
      if (data.verifyDate && data.verifyDate[0]) {
        data.revisitDateStart = data.verifyDate[0];
        data.revisitDateEnd = data.verifyDate[1];
      }
      delete data.verifyDate;
      if (data.revisitTimeNull && data.revisitTimeNull.length) {
        data.revisitDateIsNull = '1';
        delete data.revisitDateStart;
        delete data.revisitDateEnd;
        delete data.revisitTimeNull;
      } else {
        delete data.revisitTimeNull;
      }

      // 犹豫期止
      if (data.hesitateDate && data.hesitateDate[0]) {
        data.hesitateDateStart = data.hesitateDate[0];
        data.hesitateDateEnd = data.hesitateDate[1];
      }
      delete data.hesitateDate;
      if (data.hesitateTimeNull && data.hesitateTimeNull.length) {
        data.hesitateDateIsNull = '1';
        delete data.hesitateDateStart;
        delete data.hesitateDateEnd;
        delete data.hesitateTimeNull;
      } else {
        delete data.hesitateTimeNull;
      }

      // 回执状态
      if (data.receiptStatusNull && data.receiptStatusNull.length) {
        data.isNullReceiptStatus = '1';
        delete data.receiptStatusList;
        delete data.receiptStatusNull;
      } else if (data.receiptStatusList == '') {
        delete data.receiptStatusList;
        delete data.receiptStatusNull;
      } else {
        delete data.receiptStatusNull;
      }

      // 回访状态
      if (data.verifyStatusNull && data.verifyStatusNull.length) {
        data.isNullVerifyStatus = '1';
        delete data.verifyStatusList;
        delete data.verifyStatusNull;
      } else if (data.verifyStatusList == '') {
        delete data.verifyStatusList;
        delete data.verifyStatusNull;
      } else {
        delete data.verifyStatusNull;
      }

      // 业务类别
      if (data.sellTypeStatusNull && data.sellTypeStatusNull.length) {
        data.sellTypeIsNull = '1';
        delete data.sellTypeStatusNull;
      } else if (data.sellType == '') {
        delete data.sellTypeStatusNull;
      } else {
        delete data.sellTypeStatusNull;
      }

      return data;
    },
    // 获取列表
    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/commissionLog/queryUserNeedSettle',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          type: '1',
          ...this.parameter(),
          sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : ''
        }
      })
        .then(res => {
          res.data.forEach(item => {
            this.selectArr.forEach(item2 => {
              if (item.id == item2.id) {
                item._checked = true;
              }
            });
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.id); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.id); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.id) && !selectIds.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.id);
        } else if (!ids.includes(item.id) && selectIds.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.id), 1);
          selectIds.splice(selectIds.indexOf(item.id), 1);
        }
      });
    },
    ok() {
      if (!this.isAll && this.selectArr.length == 0) {
        this.$notice.alert('请至少选择一条数据');
        return;
      }
      let params = {};
      if (this.isAll) {
        params = {
          reportId: this.reportId,
          isAll: 1,
          commissionLogNeedSettleDTOList: this.selectArr,
          commissionLogNeedQuery: {
            ...this.parameter(),
            sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : '',
            type: '1'
          }
        };
      } else {
        params = {
          reportId: this.reportId,
          isAll: 0,
          commissionLogNeedSettleDTOList: this.selectArr
        };
      }
      this.$http({
        url: '/buz/userSettlementData/saveData',
        type: 'POST',
        data: params
      }).then(res => {
        this.visible = false;
        this.$notice.success('加入结算成功');
        this.$emit('success');
      });
    },
    // 导出
    exportTable() {
      let params = {
        type: '1',
        ...this.parameter(),
        settlementReportName: this.reportName,
        settlementDateStr: this.settlementDate,
        sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : ''
      }
      this.$units.downloadFile('/buz/commissionLog/exportUserNeedSettlement', params, "POST");
    },
    // 获取供应商
    getSupplier() {
      this.$http({
        url: '/buz/insuranceChannel/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        this.supplierList = res.data;
      });
    },
    // 获取保司
    getBaosi() {
      this.$http({
        url: '/buz/insuranceCompany/read/all',
        type: 'POST',
        data: {
          companyType: '1'
        }
      }).then(res => {
        //赠险公司列表初始化
        this.companyList = res.data;
      });
    },
    // 产品
    queryProduct() {
      this.$http({
        url: '/buz/productBase/read/array',
        type: 'POST',
        data: {}
      }).then(res => {
        this.productList = res.data;
      });
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.formData.supplierIds;
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/all';
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list';
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then(res => {
          this.supplierList = res.data;
        });
      }
    },
    //险种分类
    getProductTheme() {
      this.$http({
        url: '/buz/productTheme/array/first',
        type: 'GET',
        data: {}
      }).then(res => {
        //赠险公司列表初始化
        this.productThemeList = res.data;
      });
    },
    // 获取机构
    getOrgList(orgIds) {
      return this.$http({
        url: '/buz/organizationBase/queryList',
        type: 'POST',
        data: {
          ids: this.selectOrgIds
        }
      }).then(res => {
        this.orgList = res.data;
        this.$nextTick(() => {
          this.$set(this.formData, 'orgIds', orgIds);
        });
      });
    },
    // 获取当前机构业务员
    getUserList(keyword) {
      if (!keyword) {
        return;
      }
      const params = {
        orgaList: this.formData.orgIds?.length ? this.formData.orgIds : this.selectOrgIds,
        userName: keyword
      }
      return this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'POST',
        data: params
      }).then(res => {
        return res.data;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
/deep/.tip-icon {
    margin-left: 3px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #9c9c9c;
    color: #a8a6a6;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
.search-container {
  position: relative;
  .search-box {
    margin-top: 20px;
    /deep/.select-two .ivu-select {
      width: 115px !important;
      min-width: 115px;
      
      .ivu-select-selection {
        border-right: 1px solid #dcdee2 !important;
      }
    }
    /deep/.date-picker {
      min-width: 120px;
      max-width: 190px;
    }
  }
  .btn-box {
    position: absolute;
    bottom: 13px !important;
    right: -10px;
  }
  .dian {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: #35bf3f;
    border-radius: 50%;
    margin-right: 4px;
    vertical-align: top;
    transform: translateY(7px);
    &.red {
      background: #e3461f;
    }
    &.orange {
      background: #ff9900 !important;
    }
  }
}
/deep/ .ivu-icon-ios-close {
  color: #3c464f !important;
}
/deep/ .ivu-modal-body {
  padding-bottom: 30px !important;
}

.label {
  position: relative;
  .tip-icon {
    margin-left: 3px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #9c9c9c;
    color: #a8a6a6;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
  .tip-icon:hover + .pop-tip {
    opacity: 0.9;
    z-index: 9999;
    display: block;
  }
  .pop-tip {
    position: absolute;
    width: 190px;
    bottom: -40px;
    display: flex;
    align-items: center;
    text-align: left;
    left: 50%;
    margin-left: -0px;
    padding: 3px 10px;
    display: flex;
    flex-direction: column;
    background-color: #444444;
    display: none;
    border-radius: 4px;
    span {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
    }
    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #444444;
      opacity: 0.9;
      top: -4px;
      left: 29px;
      transform: rotateZ(135deg);
    }
  }
}
/deep/.ivu-modal-close {
  top: 0px;
  font-size: 30px;
}
/deep/.ivu-modal-header {
  height: 45px;
  padding-left: 20px;
}
/deep/.ivu-modal-header-inner {
  font-size: 16px;
}
.footer-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-btn {
    min-width: 100px;
    margin-right: 10px;
  }
}
</style>
